import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as moment from 'moment'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    title = 'app';

    constructor(router: Router) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                window.scrollTo(0, 0);
            }
        });
        // set datetime locale
        moment.locale('es');
    }
}



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/app.component.ts